





















































































































































































































































































































































































































































































import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import moment from 'moment'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeSuprimentosStore from '@/components/Backoffice/Store/BackofficeSuprimentosStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import BackofficeAgendamentoStore from '@/components/Backoffice/Store/BackofficeAgendamentoStore'
import { IPendenciaSolicitacao, PendenciaSolicitacao } from '@/types/implements/PendenciaSolicitacao'
import { timeoutDefault, timeout, groupCollectionByField, maskHour } from '@/utils/common'
import { EtapaEnum, SituacaoEnum, CancelarSolicitacaoParam, TipoOrigemEnum, TipoDocumentoUpload, PendenciaMensagem, TipoMensagemEnum } from '@/types/_'
import EventBus from '@/plugins/EventBus'
import ModalAdministrativePendency from './modal-administrative-pendency/modal-administrative-pendency.vue'

@Component({
  components: {
    ModalAdministrativePendency,
  },
})

export default class ComponentModalSuprimentos extends Vue {
  $refs!: { backofficeSuprimentos: any }

  loadClose: boolean = false
  loadCancelamento: boolean = false
  loadConfirmar: boolean = false
  loadPendencia: boolean = false
  showModalPendencia: boolean = false
  loadClosePendencia: boolean = false
  loadMensagem: boolean = false
  loadUpload: boolean = false
  modalConfirmarPendencia: boolean = false
  loadCloseConfirmarPendencia: boolean = false
  loadConfirmarPendencia: boolean = false
  mensagem: string = ''

  pendenciaSolicitacao: IPendenciaSolicitacao = new PendenciaSolicitacao()

  get area() {
    return this.$route.name
  }

  get getAutorizacaoAnexo() {
    if (this.getBackofficeGlobalStore.solicitacao.etapa.key === EtapaEnum.agendamento) {
      return {
        pedidoMedico: true,
        laudo: true,
        cotacaoOpme: true,
        laudoAnestesista: false,
        anexoOperadora: false,
        resumo: true,
      }
    }

    return {
      pedidoMedico: true,
      laudo: true,
      cotacaoOpme: true,
      laudoAnestesista: true,
      anexoOperadora: true,
    }
  }

  /* Pendência Administrativa */
  loadingAdministrativePendency: boolean = false
  administrativePendencyModalOpen: boolean = false

  get canOpenAdminPendency() {
    if (this.getBackofficeGlobalStore.solicitacao) {
      return this.getBackofficeGlobalStore.solicitacao.acoes.abrePendenciaAdministrativa
    }

    return false
  }

  async showModalAdministrativePendency() {
    this.loadingAdministrativePendency = true
    await timeoutDefault()
    this.administrativePendencyModalOpen = true
    this.loadingAdministrativePendency = false
  }

  async closeModalAdministrativePendency() {
    this.loadingAdministrativePendency = true
    await timeoutDefault()
    this.administrativePendencyModalOpen = false
    this.loadingAdministrativePendency = false
  }

  async acceptModalAdministrativePendency(messages: string[]) {
    this.loadingAdministrativePendency = true
    await timeoutDefault()

    this.administrativePendencyModalOpen = false

    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const response = await this.pendenciaSolicitacao.abrirPendenciaAdministrativa(solicitacaoId, { comentarios: messages })

    if (response.success) {
      this.closeModal()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao abrir a pendência administrativa.', icon: 'warning', color: '#C62828' })
    }

    await timeout(2000)

    this.loadingAdministrativePendency = false
  }

  /* Fim pendência administrativa */

  get getAutorizacao() {
    return this.getBackofficeGlobalStore.solicitacao.situacao.key === SituacaoEnum.Autorizada
      || this.getBackofficeGlobalStore.solicitacao.situacao.key === SituacaoEnum.AutorizadaParcial
      || this.getBackofficeGlobalStore.solicitacao.situacao.key === SituacaoEnum.AutorizadaAceitaMedico
      || this.getBackofficeGlobalStore.solicitacao.situacao.key === SituacaoEnum.AguardandoOperadora
  }

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  get loadingPendencia() {
    return this.loadPendencia
  }

  set loadingPendencia(value: boolean) {
    this.loadPendencia = value
  }

  get loadingClosePendencia() {
    return this.loadClosePendencia
  }

  set loadingClosePendencia(value: boolean) {
    this.loadClosePendencia = value
  }

  get loadingUpload() {
    return this.loadUpload
  }

  set loadingUpload(value: boolean) {
    this.loadUpload = value
  }

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(value: boolean) {
    this.loadMensagem = value
  }

  get loadingCloseConfirmarPendencia() {
    return this.loadCloseConfirmarPendencia
  }

  set loadingCloseConfirmarPendencia(value: boolean) {
    this.loadCloseConfirmarPendencia = value
  }

  get loadingConfirmarPendencia() {
    return this.loadConfirmarPendencia
  }

  set loadingConfirmarPendencia(value: boolean) {
    this.loadConfirmarPendencia = value
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  get loadingCancelamento() {
    return this.loadCancelamento
  }

  set loadingCancelamento(value: boolean) {
    this.loadCancelamento = value
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeSuprimentosStore() {
    return getModule(BackofficeSuprimentosStore, this.$store)
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get getPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getBackofficeAgendamentoStore() {
    return getModule(BackofficeAgendamentoStore, this.$store)
  }

  get showModalSuprimentos() {
    const show = this.getBackofficeGlobalStore.modal.suprimentos
    this.toggleHtmlOverflow(show)
    this.scrollToMensagem()
    return show
  }

  set showModalSuprimentos(val: boolean) {
    this.getBackofficeGlobalStore.setModal({ name: 'suprimentos', value: val })
  }

  get getDisplayPendencia() {
    return { nomePaciente: this.getBackofficeGlobalStore.solicitacao.paciente.nome,
      nomeMedico: this.getBackofficeGlobalStore.solicitacao.medicoSolicitante.nome }
  }

  get getMensagens() {
    return this.getPendenciaStore.pendencia.mensagens
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(texto: string) {
    this.mensagem = texto
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  get showModalConfirmarPendencia() {
    return this.modalConfirmarPendencia
  }

  set showModalConfirmarPendencia(value: boolean) {
    this.modalConfirmarPendencia = value
  }

  @Watch('showModalSuprimentos')
  async onChangeShowModalSuprimentos(value) {
    const { codigoHospital } = this.$refs.backofficeSuprimentos.$refs
    if (value === false && codigoHospital && codigoHospital.length > 0) {
      codigoHospital.forEach((e: any) => {
        e.resetValidation()
        e.reset()
      })
    }
    !value && await this.getBackofficeGlobalStore.desbloquearSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  groupByDate(value: any) {
    return groupCollectionByField(value)
  }

  clearMensagem() {
    this.getPendenciaStore.clearMensagem()
  }

  getArea() {
    return this.$route.name
  }

  isValidCotacaoOuValorUnitario(grupo: any[]) {
    if (!this.getBackofficeGlobalStore.solicitacao.configuracaoOpme.precificaValorUnitario) return true
    // @ts-ignore
    const truthyValues = []
    // @ts-ignore
    grupo.forEach((e: any) => e.opmes.forEach((o: any) => truthyValues.push(o.fazCotacao || +o.valorUnitario > 0)))

    // @ts-ignore
    return truthyValues.every(e => e === true)
  }

  isValidCodigoHospital(grupo: any[]) {
    if (!this.getBackofficeGlobalStore.solicitacao.configuracaoOpme.fazCodificacaoDeOpme) return true
    // @ts-ignore
    const truthyValues = []
    // @ts-ignore
    grupo.forEach((e: any) => e.opmes.forEach((o: any) => truthyValues.push(![undefined, null, ''].includes(o.codigoHospital))))
    // @ts-ignore
    return truthyValues.every(e => e === true)
  }

  async pendencia() {
    this.loadingPendencia = true
    await timeout(800)
    this.showModalPendencia = true
    this.loadingPendencia = false
  }

  async closeModalPendencia() {
    if (this.getBackofficeGlobalStore.valorNegociadoLoading) return
    this.loadingClosePendencia = true
    await timeoutDefault()
    this.showModalPendencia = false
    this.loadingClosePendencia = false
  }

  async closeModalConfirmarPendencia() {
    this.loadingCloseConfirmarPendencia = true
    await timeoutDefault()
    this.showModalConfirmarPendencia = false
    this.loadingCloseConfirmarPendencia = false
  }

  async inputFileAgendamento(newFile, oldFile) {
    this.loadingUpload = true
    if (newFile.identifier) {
      return
    }

    const form = new FormData()
    form.append('laudos', newFile.file)
    const time = moment().format('YYYY-MM-DDTHH:mm:ss')

    const param: any = {
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      tipoDocumento: TipoDocumentoUpload.PendenciaHospital,
      formData: form,
    }

    const response = await this.getPendenciaStore.uploadDocumento(param)

    if (response.success) {
      const result = response.data[0]
      const documentoId = result.id
      const { url } = result
      const { nomeArquivo } = result

      const pendenciaMensagem: PendenciaMensagem = {
        mensagemHospital: true,
        id: documentoId,
        dataEnvio: time,
        tipoMensagem: TipoMensagemEnum.Documento,
        texto: '',
        documentoId,
        url,
        nomeArquivo,
      }

      this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    }

    this.loadingUpload = false
  }

  async confirmarPendencia() {
    this.loadingConfirmarPendencia = true

    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const { mensagens } = this.getPendenciaStore.pendencia
    const response = await this.pendenciaSolicitacao.abrirMensagem(solicitacaoId, mensagens)

    if (response.success) {
      this.getBackofficeAgendamentoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
      this.closeModal()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao enviar a pendência.', icon: 'warning', color: '#C62828' })
    }

    await timeout(2000)
    this.loadingConfirmarPendencia = false
  }

  async sendMensagem() {
    this.loadingMensagem = true
    await timeoutDefault()

    const time = moment().format('YYYY-MM-DDTHH:mm')
    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital: true,
      id: '',
      dataEnvio: time,
      tipoMensagem: TipoMensagemEnum.Texto,
      texto: this.getMensagem,
    }

    this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    this.getMensagem = ''
    this.loadingMensagem = false
  }

  async confirmar() {
    this.loadingConfirmar = true

    if (this.getPendenciaStore.pendencia.mensagens.length > 0) {
      this.showModalConfirmarPendencia = true
      this.loadingConfirmar = false
      return
    }

    if (this.temNaoInformadoComoFornecedor()) {
      this.showModalConfirmarFornecedor = true
      this.naoInformadoOuNaoHomologado = 'informado'
      this.loadingConfirmar = false
      return
    }

    if (this.temNaoHomologadoComoFornecedor()) {
      this.showModalConfirmarFornecedor = true
      this.naoInformadoOuNaoHomologado = 'homologado'
      this.loadingConfirmar = false
      return
    }

    const grupo = this.grupoOpmeDaSolicitacao()

    if (this.isValidCodigoHospital(grupo)) {
      if (this.isValidCotacaoOuValorUnitario(grupo)) {
        const response = await this.getBackofficeGlobalStore.backofficeSuprimentosAvaliaMaterial(grupo)
        if (response.success) {
          EventBus.$emit('setSnackbar', { show: true, text: `Materiais avaliados com sucesso. ${String.fromCodePoint(0x1F642)}`, icon: 'done', color: '#2E7D32' })
          this.loadingClose = true
          await this.getBackofficeSuprimentosStore.loadAgendamentosMedicoSearch()
          this.loadingClose = false
          await this.closeModal()
        } else {
          EventBus.$emit('setSnackbar', { show: true, text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um problema com essa requisição. ${String.fromCodePoint(0x1F615)}`, icon: 'warning', color: '#C62828' })
        }
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Se não há valor unitário de um OPME é necessário fazer sua cotação...', icon: 'warning', color: '#C62828', timeout: 5500 })
      }
    } else {
      const { codigoHospital } = this.$refs.backofficeSuprimentos.$refs
      if (codigoHospital && codigoHospital.length > 0) codigoHospital.forEach((e: any, index) => e.validate())
      EventBus.$emit('setSnackbar', { show: true, text: 'Por favor, preencha todos os campos requeridos', icon: 'warning', color: '#C62828' })
    }
    this.loadingConfirmar = false
  }

  async closeModal() {
    this.showModalSuprimentos = false
    this.loadingClose = false
    let solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    this.getPendenciaStore.clearPendencia()
    await this.getBackofficeSuprimentosStore.loadAgendamentosMedicoSearch(solicitacaoId)
    solicitacaoId = ''
  }

  async showModalCancelamento() {
    this.loadingCancelamento = true
    await timeoutDefault()
    const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      tipoOrigem: TipoOrigemEnum.Agendamento,
      situacao: this.getBackofficeGlobalStore.solicitacao.situacao,
      canceladoMotivo: {
        display: '',
        key: '',
      },
      modal: 'triagem',
    }

    if (this.getBackofficeGlobalStore.solicitacao.canceladoMotivo) {
      cancelarSolicitacaoParam.canceladoMotivo = this.getBackofficeGlobalStore.solicitacao.canceladoMotivo
    }

    this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(cancelarSolicitacaoParam)
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoTriagem(true)
    await this.getSolicitacaoCancelamentoStore.getMotivosCancelamentoAll({ hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId })
    this.loadingCancelamento = false
  }

  toggleHtmlOverflow(isOpen: Boolean) {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
        document.getElementsByClassName('v-dialog')[0].scrollTop = 0
      }
    }
  }

  grupoOpmeDaSolicitacao() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    return grupoOpmeDaSolicitacao.reduce((acc: any, obj: any) => {
      const opmes = obj.opmes.reduce((y: any, x: any) => {
        y.push({
          opmeId: x.opmeId,
          codigoHospital: x.codigoHospital,
          fazCotacao: !!x.fazCotacao,
          precificado: !!x.precificado,
          necessitaDeProfissionalAdicional: !!x.necessitaDeProfissionalAdicional,
          valorUnitario: x.valorUnitario,
          valorNegociado: x.valorNegociado,
        })
        return y
      }, [])

      acc.push({ id: obj.id, opmes })

      return acc
    }, [])
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('scroll_top_suprimentos')
    if (ele.length > 0) {
      ele[0].scrollTo(0, 0)
    }
  }

  windowWidth: number = 0
  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  /**
   * FORNECEDOR NÃO INFORMADO OU NÃO HOMOLOGADO
   */

  modalConfirmarFornecedor: boolean = false
  get showModalConfirmarFornecedor() {
    return this.modalConfirmarFornecedor
  }

  set showModalConfirmarFornecedor(value: boolean) {
    this.modalConfirmarFornecedor = value
  }

  loadEditFornecedores: boolean = false

  get loadingEditFornecedores() { return this.loadEditFornecedores }
  set loadingEditFornecedores(value: boolean) { this.loadEditFornecedores = value }

  async openModalEditarFornecedorOPME() {
    this.loadingEditFornecedores = true
    const request = await this.getBackofficeGlobalStore.getFornecedoresFromApi()
    if (request && request.length > 0) {
      this.getBackofficeGlobalStore.setModal({ name: 'modalEditarFornecedorOPME', value: true })
      this.showModalConfirmarFornecedor = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || `Ocorreu um erro ao buscar fornecedores... ${String.fromCodePoint(0x1f615)}`, icon: 'warning', color: '#C62828' })
    }
    this.loadingEditFornecedores = false
  }

  naoInformadoOuNaoHomologadoInput: string = 'informado'
  get naoInformadoOuNaoHomologado() { return this.naoInformadoOuNaoHomologadoInput }
  set naoInformadoOuNaoHomologado(value: string) { this.naoInformadoOuNaoHomologadoInput = value }

  temNaoInformadoComoFornecedor() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    if (grupoOpmeDaSolicitacao.length === 0) return false
    const algumNaoInformado: boolean[] = []
    grupoOpmeDaSolicitacao.forEach((grupo: any) => {
      grupo.opmes.forEach((opme: any) => {
        if (!opme.fornecedor1) algumNaoInformado.push(false)
        if (!opme.fornecedor2) algumNaoInformado.push(false)
        if (!opme.fornecedor3) algumNaoInformado.push(false)

        // Caso não exista a flag de alertaFornecedorNaoInformado, utilizar o método antigo
        const invalido = (f: string) => {
          const e = f
          return opme[e] === undefined
            ? false
            : opme[e].nome.toUpperCase() === 'NÃO INFORMADO' || !!opme[e].alertaFornecedorNaoInformado
        }

        algumNaoInformado.push(invalido('fornecedor1'))
        algumNaoInformado.push(invalido('fornecedor2'))
        algumNaoInformado.push(invalido('fornecedor3'))
      })
    })
    return algumNaoInformado.some((e: boolean) => e)
  }

  temNaoHomologadoComoFornecedor() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    if (grupoOpmeDaSolicitacao.length === 0) return false
    const algumNaoHomologado: boolean[] = []
    grupoOpmeDaSolicitacao.forEach((grupo: any) => {
      grupo.opmes.forEach((opme: any) => {
        if (!opme.fornecedor1) algumNaoHomologado.push(false)
        if (!opme.fornecedor2) algumNaoHomologado.push(false)
        if (!opme.fornecedor3) algumNaoHomologado.push(false)

        algumNaoHomologado.push(!!opme.fornecedor1 && !!opme.fornecedor1.alertaFornecedorNaoHomologado)
        algumNaoHomologado.push(!!opme.fornecedor2 && !!opme.fornecedor2.alertaFornecedorNaoHomologado)
        algumNaoHomologado.push(!!opme.fornecedor3 && !!opme.fornecedor3.alertaFornecedorNaoHomologado)
      })
    })
    return algumNaoHomologado.some((e: boolean) => e)
  }
}
